import { render, staticRenderFns } from "./FundPositionDetails.vue?vue&type=template&id=9a2119fc&scoped=true"
import script from "./FundPositionDetails.vue?vue&type=script&lang=js"
export * from "./FundPositionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2119fc",
  null
  
)

export default component.exports